import { render, staticRenderFns } from "./showSubject.vue?vue&type=template&id=48b1b698&scoped=true"
import script from "./showSubject.vue?vue&type=script&lang=js"
export * from "./showSubject.vue?vue&type=script&lang=js"
import style0 from "./showSubject.vue?vue&type=style&index=0&id=48b1b698&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1b698",
  null
  
)

export default component.exports